import { HttpClient , HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {DataTablesModule} from 'angular-datatables';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { GoogleChartsModule } from 'angular-google-charts';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AgGridModule } from 'ag-grid-angular';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MyapplicationComponent } from './myapplication/myapplication.component';
import { MyprofileComponent } from './myprofile/myprofile.component';
//import { ApplyNewMigrationCertificateComponent } from './apply-new-migration-certificate'
import { ApplyNewMigrationCertificateComponent } from './apply-new-migration-certificate/apply-new-migration-certificate.component';
import { ViewapplicationstatusComponent } from './viewapplicationstatus/viewapplicationstatus.component';
import { FooterComponent } from './footer/footer.component';
import { ViewpdfComponent } from './viewpdf/viewpdf.component';
import { RegisterComponent } from './register/register.component';
import { DuplicateMigrationCertificateComponent } from './duplicate-migration-certificate/duplicate-migration-certificate.component';
import { UpdaterequeststatusComponent } from './updaterequeststatus/updaterequeststatus.component';
import { ViewallrequestComponent } from './viewallrequest/viewallrequest.component';
import { BoardloginComponent } from './boardlogin/boardlogin.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { UpdatefeesComponent } from './updatefees/updatefees.component';
import { ApplyNameChangeComponent } from './apply-name-change/apply-name-change.component';
import { ApplyDuplicatePassingCertificateComponent } from './apply-duplicate-passing-certificate/apply-duplicate-passing-certificate.component';
import { ApplyDuplicateMarksheetComponent } from './apply-duplicate-marksheet/apply-duplicate-marksheet.component';
import { PaymentResponceLandingComponent } from './payment-responce-landing/payment-responce-landing.component';
import { ApplyNameChangeOnPassingcertificateComponent } from './apply-name-change-on-passingcertificate/apply-name-change-on-passingcertificate.component';
import { ViewApplicationDetailsComponent } from './view-application-details/view-application-details.component';
import { ViewApplicationStatusDetailsComponent } from './view-application-status-details/view-application-status-details.component';
import { GenerateMigrationCertificateComponent } from './generate-migration-certificate/generate-migration-certificate.component';
import { AddBoardUserComponent } from './add-board-user/add-board-user.component';
import { ViewAllOtherRequestsComponent } from './view-all-other-requests/view-all-other-requests.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    MyapplicationComponent,
    MyprofileComponent,
    ApplyNewMigrationCertificateComponent,
    ViewapplicationstatusComponent,
    FooterComponent,
    ViewpdfComponent,
    RegisterComponent,
    DuplicateMigrationCertificateComponent,
    UpdaterequeststatusComponent,
    ViewallrequestComponent,
    BoardloginComponent,
    ForgetpasswordComponent,
    UpdatefeesComponent,
    ApplyNameChangeComponent,
    ApplyDuplicatePassingCertificateComponent,
    ApplyDuplicateMarksheetComponent,
    PaymentResponceLandingComponent,
    ApplyNameChangeOnPassingcertificateComponent,
    ViewApplicationDetailsComponent,
    ViewApplicationStatusDetailsComponent,
    GenerateMigrationCertificateComponent,
    AddBoardUserComponent,
    ViewAllOtherRequestsComponent,
  ],
  imports: [
    BrowserModule,
    DataTablesModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    GoogleChartsModule,//google charts for dashboard
    NgxCaptchaModule,
    AgGridModule.withComponents([]),


  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
